import { pages } from "@routes/pages";

import { MarketTypeItem } from "../MarketTypeItem";
import { typesManagementPageFor } from "../typesManagementPageFor";

export default typesManagementPageFor(MarketTypeItem, pages.marketTypes);
